"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var merge_mapper_1 = require("../../Data/merge-mapper");
var storable_realtime_subscriptions_1 = __importDefault(require("../../Data/storable-realtime-subscriptions"));
var data_entity_1 = require("../../data-entity");
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var array_utils_1 = require("../../utils/array-utils");
var Customer_consts_1 = require("../Customer.consts");
var customers_service_1 = __importDefault(require("./customers-service"));
var CustomersApi = /** @class */ (function () {
    function CustomersApi(session) {
        var _this = this;
        this.customersStore = new data_store_1.default(undefined, { shallow: true });
        this.customersService = new customers_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.customersStore, function (customer) {
            return merge_mapper_1.mergeMapper.mergeIntoExisting(_this.customersStore, customer);
        });
        this.storableRealtimeSubscriptions = new storable_realtime_subscriptions_1.default(session, this.customersStore, this.storableDataService);
        this.storableRealtimeSubscriptions.updateStoreOnEvents([
            { name: Customer_consts_1.RealtimeEvents.Created, isDelete: false },
            { name: Customer_consts_1.RealtimeEvents.Updated, isDelete: false },
            {
                name: Customer_consts_1.RealtimeEvents.Deleted,
                isDelete: true,
                itemExtractor: function (payload) { return ({ id: payload.customer_id }); }
            }
        ]);
    }
    CustomersApi.prototype.onCreate = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Customer_consts_1.RealtimeEvents.Created, function (item) { return callback(item.current); });
    };
    CustomersApi.prototype.add = function (customer) {
        return this.storableDataService.updateInStores(customer);
    };
    CustomersApi.prototype.getAll = function () {
        return this.customersStore.getAll();
    };
    CustomersApi.prototype.get = function (id) {
        return this.customersStore.get(id);
    };
    CustomersApi.prototype.loadAll = function (params, options) {
        var _this = this;
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        var loadResult;
        var loadFunc = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.customersService.loadAll(params)];
                    case 1:
                        result = _a.sent();
                        loadResult = result;
                        return [2 /*return*/, result.items];
                }
            });
        }); };
        var promise = params
            ? this.storableDataService.loadMany('loadAll', loadFunc, [], options)
            : this.storableDataService.loadAll('loadAll', loadFunc, options);
        return promise.then(function (customers) {
            return __assign(__assign({}, loadResult), { items: customers });
        });
    };
    CustomersApi.prototype.loadMany = function (ids, options) {
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storableDataService.loadMany('batchGet', function (idsToLoad) { return __awaiter(_this, void 0, void 0, function () {
                        var results;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!options.chunkSize) return [3 /*break*/, 1];
                                    return [2 /*return*/, this.customersService.loadMany(idsToLoad)];
                                case 1: return [4 /*yield*/, Promise.all(array_utils_1.arrayUtils.splitToChunks(idsToLoad, options.chunkSize).map(function (idsChunk) {
                                        return _this.customersService.loadMany(idsChunk);
                                    }))];
                                case 2:
                                    results = _a.sent();
                                    return [2 /*return*/, lodash_1.default.flatten(results)];
                            }
                        });
                    }); }, ids, options)];
            });
        });
    };
    CustomersApi.prototype.load = function (id, options) {
        var _this = this;
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        return this.storableDataService.load('load', function () { return _this.customersService.load(id); }, id, options);
    };
    CustomersApi.prototype.find = function (params) {
        return this.customersService.find(params);
    };
    CustomersApi.prototype.getTasks = function (id, page) {
        return this.customersService.getTasks(id, page);
    };
    CustomersApi.prototype.getTotalTasks = function (id) {
        return this.customersService.getTotalTasks(id);
    };
    CustomersApi.prototype.update = function (customerData) {
        var _this = this;
        return this.storableDataService.modify('update', function () { return _this.customersService.update(customerData); });
    };
    CustomersApi.prototype.create = function (customerData) {
        var _this = this;
        return this.storableDataService.modify('create', function () { return _this.customersService.create(customerData); });
    };
    return CustomersApi;
}());
exports.default = CustomersApi;
//# sourceMappingURL=customers-api.js.map